<h5>Jugadores</h5>

<div class="row">
  @for (drawing of drawings(); track drawing.id) {
    <div class="col-sm-6 col-md-4 col-lg-3 col-xxxl-2">
      <player-ui
        [drawing]="drawing"
      ></player-ui>
    </div>
  }
</div>
